import { ReactNode } from 'react'
import { Spacer } from '@vinted/web-ui'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import ResponsiveWrapper from '../../ReponsiveWrapper'

type Props = {
  children: Array<ReactNode>
}

const FactsSection = ({ children }: Props) => (
  <section>
    <div className="page-section__facts">
      <SeparatedList
        separator={
          <ResponsiveWrapper
            mobile={<Spacer size="x2-large" />}
            desktop={<Spacer size="x2-large" orientation="vertical" />}
          />
        }
      >
        {children}
      </SeparatedList>
    </div>
    <ResponsiveWrapper mobile={<Spacer size="x2-large" />} desktop={<Spacer size="x4-large" />} />
  </section>
)

export default FactsSection
